let config = {
  basURL: "https://manasa.easytech-sotfware.com/",
};

export default config;
